import { create } from 'zustand'
import type { AuthUser } from '../types'

const TOKEN_KEY = 'codetobyte-token'
const USER_KEY  = 'codetobyte-user'

interface AuthState {
  user: AuthUser | null
  token: string | null
  isLoggedIn: boolean
  setAuth: (user: AuthUser, token: string) => void
  logout: () => void
  /** Rehydrate from localStorage on app load */
  rehydrate: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  isLoggedIn: false,

  setAuth(user, token) {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
    set({ user, token, isLoggedIn: true })
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    set({ user: null, token: null, isLoggedIn: false })
  },

  rehydrate() {
    const token = localStorage.getItem(TOKEN_KEY)
    const raw   = localStorage.getItem(USER_KEY)
    if (token && raw) {
      try {
        const user = JSON.parse(raw) as AuthUser
        set({ user, token, isLoggedIn: true })
      } catch {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USER_KEY)
      }
    }
  },
}))
